type DraftValues = Record<string, unknown>

export function readFormDraft<T extends DraftValues>(key: string): T | null {
  if (!key || typeof window === 'undefined') return null

  try {
    const raw = window.localStorage.getItem(key)
    if (!raw) return null

    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null

    return parsed as T
  } catch {
    return null
  }
}

export function writeFormDraft(key: string, values: DraftValues): void {
  if (!key || typeof window === 'undefined') return

  try {
    window.localStorage.setItem(key, JSON.stringify(values))
  } catch {
    // Ignore storage errors (quota/private mode/etc)
  }
}

export function clearFormDraft(key: string): void {
  if (!key || typeof window === 'undefined') return

  try {
    window.localStorage.removeItem(key)
  } catch {
    // Ignore storage errors
  }
}
